/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import Card from '../../../components/card.component';
import {
  Col,
  Row,
} from 'react-bootstrap';
import { ConfigContext } from '../../../context/config.context';
import masterFunction from '../../master/master.functions';
import reportesFunctions from '../reportes.functions';
import PesoPiesPrinter from '../imprimir/pesopies.printer';
import notification from '../../../components/notification.component';
import MasterComponent from '../../../components/master.component';

const MasterTotales = () => {

  const { config } = useContext(ConfigContext);
  const [dataRpOne, setDataRp] = useState(null);
  const [master, setMaster] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [filterData, setFilterData] = useState([]);
  
  const generarReporteOne = () => {
    if (filterData.length) {
      reportesFunctions.pesoPies({ master_ids: filterData }).then((response) => {
        if (!response.error) {
          setDataRp(response.totales);
        } else {
          notification.warning('Ocurrio un error, intentelo nuevamente');
        }
      })
    } else {
      notification.warning('Debes seleccionar al menos una guia master');
    }
  }

  const resetReportOne = () => {
    setToggle(!toggle);
    setDataRp(null);
  }

  useEffect(() => {
    listMaster();
  },[]);

  const listMaster = () => {
    masterFunction.listadoFiltro().then((response) => {
      setMaster(response);
    })
  }


  const gestorSelector = (data) => {
    const filter_data = data.selectedRows.map((e) => e.id);
    setFilterData(filter_data);
  }

  return (
    <Row className="mt-3">
      <Col>
        <Card>
          <div>
            <MasterComponent 
              onSeleccting={(data, tipo) => gestorSelector(data, tipo)}
              filtre={'filtro_master_guia'}
              tipo="filtro_master_guia"
              clear={toggle}
              all={false}
             />
          </div>
          <div className="mt-2 d-flex">
           <button onClick={generarReporteOne} type="button" className="btnx btnx-warn">Generar</button> {' '}
           <button onClick={resetReportOne} type="button" className="btnx btnx-warn">Limpiar</button> {' '}
           {dataRpOne !== null ? <PesoPiesPrinter config={config} data={dataRpOne} /> : null}
          </div>
        </Card>
      </Col>
    </Row>
  )
}

export default MasterTotales;